import { useEffect } from 'react';

/**
 * @hook автоскролл в верх страницы при смене страницы
 */

const useScrollUpPage = (pageNumber: number) => {
  useEffect(() => {
    if (pageNumber) {
      window.scrollTo(0, 0);
    }
  }, [pageNumber]);
};

export default useScrollUpPage;
